import React, { useEffect, useState } from 'react';
import { Form } from 'formik';
import FormTextField from 'components/formComponents/FormTextField';
import LanguageSearchDropdown from 'components/languageSearchDropdown/languageSearchDropdown';
import { useFormikContext } from 'formik';
import { ErrorM } from 'components/formComponents/ErrorM';
import FileUploadPanel from '../../helpers//FileUploadPanel/FileUploadPanel';

export const UpdateSchoolForm = (props:  any) => {
  const formikContext = useFormikContext();

  const languageList = [
    { value: 'english', label: 'English' },
    { value: 'french', label: 'French' },
    { value: 'italian', label: 'Italian' },
    { value: 'german', label: 'German' },
  ];

  const [languageOption, setLanguageOption] = useState<any>({
    value: '',
    label: '',
  });

  const [langDropdownToggle, setLangDropdownToggle] = useState<boolean>(false);
  function toggleLanguageDropdown() {
    setLangDropdownToggle((prevState) => !prevState);
  }

  useEffect(() => {
    const langOpt = languageList.filter(
      (langItem) =>
        langItem.value === formikContext.getFieldProps('country').value
    )[0];

    langOpt
      ? setLanguageOption(langOpt)
      : setLanguageOption({ value: 'english', label: 'English' });
  }, []);

  return (
    <Form>
      <FormTextField
        label="School name"
        field="schoolName"
        required={true}
        labelPosition="left"
        value={formikContext.getFieldProps('schoolName').value}
      />
      <FormTextField
        label="School phone number"
        field="schoolPhoneNumber"
        required={true}
        labelPosition="left"
        value={formikContext.getFieldProps('schoolPhoneNumber').value}
      />

      <h4 className="SpaceTopBtm">School Address</h4>

      <FormTextField
        label="Address line 1"
        field="addressLine1"
        required={true}
        labelPosition="left"
        value={formikContext.getFieldProps('addressLine1').value}
      />
      <FormTextField
        label="Address line 2"
        field="addressLine2"
        labelPosition="left"
        required={false}
        optionalTag={'optional'}
        value={formikContext.getFieldProps('addressLine2').value}
      />
      <FormTextField
        label="Address line 3"
        field="addressLine3"
        labelPosition="left"
        required={false}
        optionalTag={'optional'}
        value={formikContext.getFieldProps('addressLine3').value}
      />
      <FormTextField
        label="Town/City"
        field="townCity"
        required={true}
        labelPosition="left"
        value={formikContext.getFieldProps('townCity').value}
      />
      <FormTextField
        label="County"
        field="county"
        labelPosition="left"
        required={false}
        optionalTag={'optional'}
        value={formikContext.getFieldProps('county').value}
      />
      <FormTextField
        label="Postcode/Zipcode"
        field="postcodeZipcode"
        required={true}
        labelPosition="left"
        value={formikContext.getFieldProps('postcodeZipcode').value}
      />
      <FormTextField
        label="Country"
        field="country"
        required={true}
        labelPosition="left"
        value={formikContext.getFieldProps('country').value}
      />
      <FormTextField
        label="Finance email"
        field="financeEmail"
        required={true}
        labelPosition="left"
        value={formikContext.getFieldProps('financeEmail').value}
      />
      <FileUploadPanel 
        label="School logo"
        field="schoolLogo"
        dropzoneText="Upload logo"
        onFileUploadEnd={(file) => {
          props.setSchoolLogoFile(file);
          props.setSchoolLogoUrl(null);
          props.setSchoolLogoUpdated(true);
        }}
        fileType={"image"}
        file={props.schoolLogoUrl ? props.schoolLogoUrl : props.schoolLogoFile}
        uploadedImageUrl={props.schoolLogoUrl}
        fileName={props.schoolLogoUrl ? "saved_school_logo" + props.schoolLogoExt : ""}
        acceptedTypes={['.png', '.jpg', '.jpeg']}
      />
      <p className="MinusMarginTop">Upload only .png, .jpg and .jpeg images</p>
      <div className="LineSpacer3"></div>
      {(props.schoolLogoFile || props.schoolLogoUrl) &&
        <div className="Checkbox">
          <input
            type="checkbox"
            id="RemoveSchoolLogo"
            checked={props.removeSchoolLogo}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              props.setRemoveSchoolLogo(e.target.checked)
            }
          />
          <label className="CustomInput" htmlFor="RemoveSchoolLogo">
            Remove Logo
          </label>
        </div>
      }           
      {/* <div className="FormBox FormSideBySide left">
        <div className="FormLabel">Country</div>
        <div className="FormField">
          <LanguageSearchDropdown
            isOpen={langDropdownToggle}
            options={languageList}
            value={languageOption}
            onChange={(e) => {
              formikContext.setFieldValue('country', e.value);
              setLanguageOption(e);
              toggleLanguageDropdown();
            }}
            toggleDropdown={() => {
              toggleLanguageDropdown();
            }}
          />
          <ErrorM name={'country'} />
        </div>
      </div> */}
    </Form>
  );
};
